module.exports = __webpack_public_path__ + "static/media/mainSlide7.94664ad6.jpg";